import { CSSProperties, useEffect, useState } from "react";
//@ts-ignore
import Rodal from "rodal";
import "rodal/lib/rodal.css";
import "./styles.css";

type AnimationModal =
  | "zoom"
  | "fade"
  | "flip"
  | "door"
  | "rotate"
  | "slideUp"
  | "slideDown"
  | "slideLeft"
  | "slideRight";

type ModalComponentProps = {
  visible: boolean;
  contentStyle?: CSSProperties;
  animation?: AnimationModal;
  contained?: boolean;
};

const defaultStyle = {
  background: "transparent",
  border: "none",
  outline: "none",
  boxShadow: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
} as CSSProperties;

export function Loading({
  animation = "zoom",
  contentStyle,
  visible,
  contained = false,
}: ModalComponentProps) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  useEffect(() => setIsLoading(visible), [visible]);

  const spinner = (
    <div className="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );

  if (contained) {
    return isLoading ? (
      <div className="loading__contained" role="status" aria-label="Carregando">
        {spinner}
      </div>
    ) : null;
  }

  return (
    <Rodal
      customStyles={defaultStyle || contentStyle}
      animation={animation}
      visible={isLoading}
      onClose={() => { }}
    >
      {spinner}
    </Rodal>
  );
}
